__turbopack_context__.v({
  "blog_count": "styles-module-scss-module__UG5PBW__blog_count",
  "card_outer": "styles-module-scss-module__UG5PBW__card_outer",
  "search": "styles-module-scss-module__UG5PBW__search",
  "search_bar": "styles-module-scss-module__UG5PBW__search_bar",
  "spinner": "styles-module-scss-module__UG5PBW__spinner",
  "state_sort": "styles-module-scss-module__UG5PBW__state_sort",
  "zero_state": "styles-module-scss-module__UG5PBW__zero_state",
});
